import { Environment } from './environment.model';

export const environment: Environment = {
  envName: 'int',
  apiUrl: 'https://ovg-api.dev.tv2sc.dk',
  useProxy: false,
  awsCognitoConfig: {
    identityPoolId: 'eu-north-1:24fcf188-814a-45c2-9ed4-1d9ac61b75f0',
    userPoolId: 'eu-north-1_5lw4LRoVB',
    userPoolWebClientId: '40rsc48egc9i4p5eb9ga7let4n',
    region: 'eu-north-1',
    mandatorySignIn: true,
    oauth: {
      domain: 'ovg-int.auth.eu-north-1.amazoncognito.com',
      scope: ['email', 'openid', 'profile'],
      redirectSignIn: 'https://ovg-ux.dev.tv2sc.dk',
      redirectSignOut: 'https://ovg-ux.dev.tv2sc.dk',
      responseType: 'code',
    },
    headerXHostOverride: false,
    tokenRefreshCheckPeriod: 5000,
    tokenDurationSafeBufferFactor: 0.8,
  },
};
